// composables/useUnifiedAuth.js
import { useCheckoutAuthStore } from '~/layers/checkout/store/checkoutAuthStore'
export const useUnifiedAuth = () => {

  const intranetAuthStore = useAuthIntranetStore();
  const authStore = useCheckoutAuthStore()

  const config = useRuntimeConfig()

  const isLoggedIn = computed(() => {

    if (config.public.IS_INTRANET == 1) {
      return intranetAuthStore.isLoggedInIntranet
    } else {
      return authStore.isLoggedIn
    }
  })
  // whenever needed
  // const user = computed(() => {
  //   if (config.public.IS_INTRANET == 1) {
  //     return intranetAuthStore.user
  //   }
  //   // todo check when uncommented with functionality
  //   return authStore.customerId
  // })  

  return {

    isLoggedIn,
    // user,
  }
}